import React, {PropsWithChildren, useEffect, useState} from 'react';

import Close from '../../assets/icons/close-black.svg';
import {cn} from '../../utils/reusableFunctions';

type Props = {
  isVisible: boolean;
  onClose: () => void;
  className?: string;
  containerStyle?: string;
  showCloseIcon?: boolean;
  dismissOnClickOutside?: boolean;
};

const Modal = ({
  isVisible,
  onClose,
  className,
  containerStyle,
  children,
  showCloseIcon = false,
  dismissOnClickOutside = false,
}: PropsWithChildren<Props>) => {
  const [animate, setAnimate] = useState(false);

  const handleModal = (event: React.MouseEvent<HTMLDivElement>) =>
    event.stopPropagation();

  const handleWrapperClick = () => {
    if (dismissOnClickOutside) {
      onClose();
    }
  };

  useEffect(() => {
    const body = document.querySelector('body');
    isVisible
      ? body?.classList.add('overflow-hidden')
      : body?.classList.remove('overflow-hidden');
  }, [isVisible]);

  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (isVisible) {
      setAnimate(false);
      timeout = setTimeout(() => setAnimate(true), 100); // slight delay for transition
    } else {
      setAnimate(false);
    }
    return () => clearTimeout(timeout);
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div
      className={cn(
        'fixed inset-0 z-50 flex justify-center items-center transition-colors invisible',
        {'visible bg-black/60': isVisible},
        containerStyle
      )}
      id="wrapper"
      onClick={handleWrapperClick}>
      <div
        className={cn(
          'bg-white shadow transition-all duration-300 h-inherit rounded-2xl w-[90%] md:w-[600px] opacity-0 -translate-y-24',
          {
            'opacity-100 translate-y-0': animate,
          },
          className
        )}
        id="modal"
        onClick={handleModal}
        // style={{position: 'relative'}}
      >
        {showCloseIcon && (
          <button
            type="button"
            aria-label="Close"
            onClick={onClose}
            className="absolute top-5 right-3 text-gray-500 hover:text-gray-700 text-2xl">
            <img src={Close} alt="Close Icon" className="w-4 h-4 mr-1" />
          </button>
        )}
        {children}
      </div>
    </div>
  );
};

export default Modal;
